import { atom, useRecoilValue, useSetRecoilState } from "recoil";
import { getNotification, sendReadNotificatio } from "_services";

const handleGetNotifications = () => ({ setSelf }) => {
  getNotification().then(({ data }) =>
    setSelf(data.sort((a, b) => -a.createdAt.localeCompare(b.createdAt)))
  );
};

export const notificationsState = atom({
  key: "notificationsState",
  default: [],
  effects: [handleGetNotifications()],
});

export const useNotification = () => {
  const notifications = useRecoilValue(notificationsState);
  const setNotifications = useSetRecoilState(notificationsState);

  const totalUnRead = notifications.filter((item) => item.isUnRead === true).length;

  const handleReadNotification = (id) => {
    const checkUnRead = notifications.find((noti) => noti.id === id).isUnRead;
    if (checkUnRead) {
      const result = notifications.map((notification) => {
        if (notification.id === id) {
          return {
            ...notification,
            isUnRead: false,
          };
        }
        return notification;
      });
      setNotifications(result);
      sendReadNotificatio([id]);
    }
  };

  return {
    notifications,
    totalUnRead,
    handleReadNotification,
  };
};
